<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1 class="mb-2">سوابق و کارنامه</h1>
          <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="examsList"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
          >
            <template #cell(type)="data">
              {{ usersTypeEnum[data.item.type] }}
            </template>
            <template #cell(result)="data">
              {{ data.item.result ? data.item.result : "-" }}
            </template>
            <template #cell(sessionStartTime)="data">
              {{
                new Date(data.item.sessionStartTime).toLocaleTimeString(
                  "fa-IR",
                  {
                    hour: "2-digit",
                    minute: "2-digit",
                  }
                )
              }}
              -
              {{
                new Date(data.item.sessionStartTime).toLocaleDateString("fa-IR")
              }}
            </template>
            <template #cell(actions)="data">
              <div
                class="w-100 d-flex align-items-center justify-content-center"
              >
                <b-link
                  :to="`/master/reserved/${$route.params.id}/report/${data.item.examId}`"
                  class="w-100 d-flex align-items-center justify-content-center"
                >
                  <feather-icon class="text-primary" icon="EyeIcon" size="20" />
                </b-link>
              </div>
            </template>
          </b-table>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end py-2"
          >
            <b-pagination
              v-model="pageNumber"
              :total-rows="totalCount"
              :per-page="count"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  style="transform: rotate(180deg)"
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
export default {
  watch: {
    pageNumber: {
      handler(val) {
        this.getAnExam();
      },
    },
  },
  data() {
    return {
      isLoading: false,
      scheduleDetails: null,
      pageNumber: 1,
      count: 10,
      examsList: null,
      totalCount: null,
      myTableColumns: [
        {
          key: "examId",
          label: "شناسه آزمون",
        },
        {
          key: "lessonTitle",
          label: "عنوان درس",
        },
        {
          key: "masterFullName",
          label: "نام استاد",
        },
        {
          key: "result",
          label: "نمره آزمون",
        },
        {
          key: "sessionStartTime",
          label: "تاریخ آزمون",
        },
        {
          key: "actions",
          label: "مشاهده جزئیات",
        },
      ],
    };
  },
  async mounted() {
    await this.getASingleSchedule();
    this.getAnExam();
  },
  methods: {
    async getAnExam() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllExams = new GetAllExams(_this);
        getAllExams.setRequestParam({
          studentUserId: _this.scheduleDetails.studentUserId,
          pageNumber: _this.pageNumber,
          count: _this.count,
        });
        await getAllExams.fetch((response) => {
          if (response.isSuccess) {
            _this.examsList = response.data.exams;
            if (!_this.totalCount) {
              _this.totalCount = response.data.examsCount;
            }
            console.log(response.data);
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getASingleSchedule() {
      try {
        this.isLoading = true;
        let _this = this;
        let getASingleScheduleForMaster = new GetASingleScheduleForMaster(
          _this
        );
        getASingleScheduleForMaster.setRequestParam({
          id: _this.$route.params.id,
        });
        await getASingleScheduleForMaster.fetch((response) => {
          if (response.isSuccess) {
            _this.scheduleDetails = response.data;
            // console.log(_this.scheduleDetails);
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BLink,
    BPagination,
    BOverlay,
  },
};
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BLink,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
import { GetASingleScheduleForMaster } from "@/libs/Api/Schedules";
import { GetAllExams } from "@/libs/Api/Exam";
</script>
